<app-simulation-version></app-simulation-version>
@if ((isShowStepper$ | async)) {
  <app-simulation-stepper></app-simulation-stepper>
}